/**
 * Employee Web — `/me/punch` legacy redirect.
 *
 * Phase 5 Plan 02-04 originally shipped a dedicated punch screen here. The
 * 2026-05-03 design bundle merges punch into `/me/my-attendance` (single dark
 * hero card on the attendance page), so this route now redirects there to keep
 * old deep-links / bookmarks / push-notification URLs working. See fe-076.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/me/punch")({
  staticData: { breadcrumb: { labelKey: "attendance:log.title" } },
  beforeLoad: () => {
    throw redirect({ to: "/me/my-attendance" });
  },
});
